import React, { useEffect } from 'react';

import SelectInput from 'DesignSystem2/Input/SelectInput';
import SelectOptionsPopover from 'DesignSystem2/Input/SelectOptionsPopover';
import { useStores } from 'hooks/use-stores';
import { noop } from 'utils/noop';

interface DebitCardSelectProps {
    cardId: string;
    className?: string;
    setCardId: React.Dispatch<React.SetStateAction<string>>;
}

const DebitCardSelect = ({ cardId, className = undefined, setCardId }: DebitCardSelectProps): JSX.Element => {
    const { traderStore } = useStores();
    const cards = traderStore.payments.debitCards;
    const noSavedCards = cards.length === 0;
    const options = cards.map((card) => ({
        label: `Debit card ${card.name}`,
        value: card.id,
    }));
    options.push({ label: 'Add a card', value: 'add' });
    const selectedText = options.find((option) => option.value === cardId)?.label;

    useEffect(
        () => {
            if (noSavedCards) {
                setCardId('add');
            } else {
                setCardId(options[0].value);
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    );

    if (noSavedCards) {
        return <></>;
    }

    return (
        <div className={'rounded-x30 border border-solid border-fill-x50 mt-3'}>
            <SelectOptionsPopover options={options} onSelect={setCardId}>
                <SelectInput
                    id={'deposit'}
                    labelText={'From'}
                    errorText={cardId === '' ? 'Must select card' : undefined}
                    name={'deposit-card'}
                    selectedText={selectedText}
                    onChange={noop}
                    className={className}
                />
            </SelectOptionsPopover>
        </div>
    );
};

export default DebitCardSelect;
